<!-- Reset Password redirect page -->
<div class="misc-wrapper">
  <div class="misc-inner p-2 p-sm-3">
    <div class="w-100 text-center">
      <h2 *ngIf="token">🔓 Réinitialisation du mot de passe</h2>

      <img
        class="img-fluid mt-3"
        [src]="
          coreConfig?.layout?.skin === 'dark'
            ? 'assets/images/pages/error-dark.svg'
            : 'assets/images/pages/error.svg'
        "
        alt="UTrav"
        style="max-width: 200px"
      />

      <!-- Message de chargement initial -->
      <div *ngIf="!showFallback">
        <p class="mb-2">Ouverture de l'application UTrav...</p>
        <div class="my-3">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Chargement...</span>
          </div>
        </div>
      </div>

      <!-- Options de fallback si l'app ne s'ouvre pas -->
      <div *ngIf="showFallback">
        <p class="mb-3 text-muted">L'application ne s'est pas ouverte ? Téléchargez UTrav :</p>
        <div class="d-flex justify-content-center gap-2">
          <button class="btn btn-primary mb-2" (click)="openAppStore()" rippleEffect>
            <i class="fab fa-apple mr-50"></i>
            App Store
          </button>
          <button class="btn btn-success mb-2" (click)="openPlayStore()" rippleEffect>
            <i class="fab fa-google-play mr-50"></i>
            Play Store
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- / Reset Password redirect page -->
